import { csx, style } from '@vtex/admin-ui'

export const wrapper = style({ position: 'relative' })

export const comboboxPopover = csx({
  bg: '$primary',
  zIndex: 9999,
  padding: '$space-3',
  boxShadow: '$overlay.center',
  border: '$neutral',
  borderRadius: '$base',
  display: 'flex',
  flexDirection: 'column',
})

export const comboboxPopoverWrapper = style({
  transform: 'translateY(38px) !important',
  width: '100%',
})
